module.exports = __webpack_public_path__ + "img/rajesh-pro.0328a090.jpg";